import AbstractScene from './AbstractScene.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { Colors } from '../consts/Colors.js';
import { tags } from '../consts/Tags.js';
import { B3Data } from '../consts/Data.js';
import Btn from '../prefabs/Btn.js';
import QuestionB3 from '../prefabs/QuestionB3.js';
import EndB3Item from '../prefabs/EndB3Item.js';

export default class ActiviteB3 extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteB3"
        })
    }
    init(data) {
        this._init(data);
        this.level = 0
        this.allQuestions = B3Data.questions;
        this.allAnswers = B3Data.answers;
        this.allAnswers = Phaser.Utils.Array.Shuffle(this.allAnswers);
        this.allEndItems = B3Data.endBlocks;
    }

    preload() {
        this._preload();
    }


    // update(){

    // }

    create() {
        this.addHeader(B3Data.activiteTitle);

        this.addBackgroundMusique('minimal')
    }

    launchScene() {
        this.introContainer = this.add.container(0, 0);

        let title = B3Data.introTitle
        this.introTitle = this.add.rexTagText(this.width / 2, 215, title.toUpperCase(), {
            fontSize: "36px",
            fontFamily: "DKButterfly",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1800 },
            tags: tags
        }).setAlpha(1).setOrigin(0.5)

        this.introContainer.add(this.introTitle);

        let ctnt = B3Data.introContent
        this.introContent = this.add.rexTagText(this.width / 2, 700, ctnt, {
            fontSize: "30px",
            fontFamily: "CenturyGothic",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1600 },
            tags: tags
        }).setAlpha(0).setOrigin(0.5)

        this.introContainer.add(this.introContent);

        this.illuIntro1 = this.add.image(708, 368, 'illuB3Intro1').setOrigin(0.5).setAlpha(0);
        this.illuIntro2 = this.add.image(958, 359, 'illuB3Intro2').setOrigin(0.5).setAlpha(0);
        this.illuIntro3 = this.add.image(1162, 360, 'illuB3Intro3').setOrigin(0.5).setAlpha(0);

        this.introContainer.add(this.illuIntro1);
        this.introContainer.add(this.illuIntro2);
        this.introContainer.add(this.illuIntro3);

        this.startBtn = new ButtonImageSliced(this, this.width / 2, 960, 320, 80, "bouton", "Démarrer").setAlpha(0)
        this.introContainer.add(this.startBtn);
        this.startBtn.setClickFunction(() => { this.launchMainGame() })

        this.tweens.add({
            targets: this.illuIntro1,
            alpha: 1,
            duration: 200,
            ease: 'Power2',
            delay: 200,
            onComplete: () => {
                this.tweens.add({
                    targets: this.illuIntro2,
                    alpha: 1,
                    duration: 200,
                    ease: 'Power2',
                    delay: 200,
                    onComplete: () => {
                        this.tweens.add({
                            targets: this.illuIntro3,
                            alpha: 1,
                            duration: 200,
                            ease: 'Power2',
                            delay: 200,
                            onComplete: () => {
                                this.tweens.add({
                                    targets: [this.introContent, this.startBtn],
                                    alpha: 1,
                                    duration: 500,
                                    ease: 'Power2',
                                    delay: 300
                                })
                            }
                        })
                    }
                })
            }
        })

    }


    // launchScene() {
    //     this.launchEndScreen()
    // }


    launchMainGame() {
        // launchScene() {
        this.nextBtn = new ButtonImageSliced(this, 1710, 990, 320, 80, "bouton", "Suivant").setAlpha(0)
        this.nextBtn.setClickFunction(() => {
            this.nextBtn.setAlpha(0);
            this.question.launchNext()
        })
        this.tweens.add({
            targets: this.introContainer,
            alpha: 0,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.launchQuestion();
            }
        });
    }

    launchQuestion() {
        this.questionData = this.allQuestions[this.level]
        this.question = new QuestionB3(this, this.questionData);
    }

    launchEndScreen() {
        this.items = []
        this.endContainer = this.add.container(0, 0);

        let title = B3Data.endTitle
        this.endTitle = this.add.rexTagText(this.width / 2, 215, title.toUpperCase(), {
            fontSize: "36px",
            fontFamily: "DKButterfly",
            align: 'center',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1800 },
            tags: tags
        }).setAlpha(0).setOrigin(0.5)

        let subTitle = B3Data.endSubTitle
        this.endSubTitle = this.add.rexTagText(105, 295, subTitle, {
            fontSize: "30px",
            fontFamily: "CenturyGothic",
            align: 'left',
            color: Colors.Text.Black,
            backgroundColor: "transparent",
            wordWrap: { width: 1800 },
            tags: tags
        }).setAlpha(0).setOrigin(0, 0.5)

        this.endBtn = new ButtonImageSliced(this, 1710, 990, 320, 80, "bouton", "Terminer").setAlpha(0)
        this.endBtn.setClickFunction(() => {
            if (this.game.data.level <= 6) {
                this.game.data.level = 7
            }
            this.scene.start("Menu")

        })

        this.tweens.add({
            targets: this.endTitle,
            alpha: 1,
            duration: 500,
            ease: 'Power2',
            onComplete: () => {
                this.tweens.add({
                    targets: this.endSubTitle,
                    alpha: 1,
                    duration: 500,
                    ease: 'Power2',
                    onComplete: () => {
                        this.tweens.add({
                            targets: this.endTitle,
                            alpha: 1,
                            duration: 500,
                            ease: 'Power2',
                            onComplete: () => {
                                for (let i = 0; i < this.allEndItems.length; i++) {
                                    const element = this.allEndItems[i];
                                    this.time.addEvent({
                                        delay: i * 200,
                                        callback: () => {
                                            let item = new EndB3Item(this, 380 + i * 580, 640, element);
                                            this.items.push(item);
                                            if (i === 2) {
                                                this.startItem()
                                            }
                                        }
                                    })

                                }
                            }
                        })
                    }
                })
            }
        })

    }

    startItem() {
        this.items.forEach((item, index) => {
            this.time.addEvent({
                delay: index * 600,
                callback: () => {
                    item.launchContent()
                    if (index === this.items.length - 1) {
                        this.tweens.add({
                            targets: this.endBtn,
                            alpha: 1,
                            duration: 500,
                            ease: 'Power2'
                        })
                    }
                 }
            })
        })
    }


}